import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";

class MediaScreenSelect extends Action {
    until;
    defaultAction;
    timelineMap;
    _stopper;

    constructor(props) {
        super(props);
        this.until = props.until;
        this.defaultAction = props.defaultAction && new LoadTimeline(props.defaultAction);
        this.pickAction = Object.fromEntries(props.timelineMap.map(item => [item.instanceId, new LoadTimeline(item)]));
        this._stopper = () => {};
    }

    async execute(eventLoop) {
        const getNextTimeline = (instanceId) => {
            if (this.pickAction[instanceId]) {
                return this.pickAction[instanceId];
            }

            if (this. defaultAction && this.defaultAction.timelines.length) {
                return this.defaultAction;
            }

        };

        const activateMediaScreenSelect = () => {
            VR.canvas.addEventListener('media_screen_selected', handleMediaScreenSelection);
            return () => VR.canvas.removeEventListener('media_screen_selected', handleMediaScreenSelection);
        };

        const handleMediaScreenSelection = async (event) => {
            const instanceId = event.detail.instanceId;
            const nextAction = getNextTimeline(instanceId);

            if (nextAction) {
                this._stopper();
                await nextAction.execute(eventLoop);
            }
        };

        this._stopper = activateMediaScreenSelect();
        setTimeout(this._stopper, this.until - this.startTime);
    }

    async stop() {
        this._stopper();
    }
}

export default MediaScreenSelect;
